module.exports = __webpack_public_path__ + "img/07.9360f8aa.png";